import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const LightningStrikeAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<8; i++){
    const ang = (i/8)*Math.PI*2;
    const rStart = getRadiusAtAngle(ang, e, e.maxRadius);
    ctx.beginPath(); 
    let cx = e.pos.x + Math.cos(ang) * rStart;
    let cy = e.pos.y + Math.sin(ang) * rStart;
    ctx.moveTo(cx, cy);
    for(let j=0; j<6; j++){
      cx += Math.cos(ang + (Math.random()-0.5)) * 40 * progress;
      cy += Math.sin(ang + (Math.random()-0.5)) * 40 * progress;
      ctx.lineTo(cx, cy);
    }
    ctx.stroke();
  }
};

registerBlastAnimation('LIGHTNING_STRIKE', LightningStrikeAnimation);
